/* Daki theme globals: reveal-on-scroll, FAQ single-open, #help deep link, live cart count.
   Security: DOM APIs + textContent only, no innerHTML anywhere in this theme's JS. */
(() => {
  'use strict';

  // reveal on scroll (from demo app.js)
  const reveals = document.querySelectorAll('.dk-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('dk-in'); io.unobserve(e.target); }
    }), { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach((el) => io.observe(el));
  } else reveals.forEach((el) => el.classList.add('dk-in'));
  setTimeout(() => reveals.forEach((el) => el.classList.add('dk-in')), 1500);

  // FAQ: only one open at a time
  document.querySelectorAll('.dk-faq__item').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open) document.querySelectorAll('.dk-faq__item').forEach((o) => { if (o !== item) o.open = false; });
    });
  });

  // Deep link: #help opens the getting-started modal (daki-help-modal section)
  document.addEventListener('DOMContentLoaded', () => {
    if (location.hash === '#help') {
      const hm = document.querySelector('[data-dk-help-modal]');
      if (hm) hm.style.display = 'flex';
    }
  });

  // Cart quantity stepper: adjust value, then auto-submit the cart form
  // so totals refresh without needing the Update button.
  const cartForm = document.querySelector('[data-dk-cart-form]');
  if (cartForm) {
    let t = null;
    cartForm.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-dk-qty]');
      if (!btn) return;
      const input = btn.parentElement.querySelector('input[name="updates[]"]');
      if (!input) return;
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.dkQty, 10));
      input.value = next;
      clearTimeout(t);
      t = setTimeout(() => cartForm.submit(), 500);
    });
  }

  // Live cart count in header
  const countEl = document.querySelector('[data-dk-cart-count]');
  if (countEl) {
    const refresh = () => fetch('/cart.js')
      .then((r) => (r.ok ? r.json() : null))
      .then((c) => {
        if (!c || typeof c.item_count !== 'number') return;
        countEl.textContent = String(c.item_count);
        const link = countEl.closest('.dk-nav__cart');
        if (link) link.classList.toggle('dk-nav__cart--empty', c.item_count === 0);
      })
      .catch(() => {});
    document.addEventListener('dk:cart-changed', refresh);
  }
})();
